export default __webpack_public_path__ + "58b18b96782c662b0477b26d604ad64b.jpg";